<template>
  <v-container class="pt-0" fluid>
    <v-card class="px-5 py-3 br-15 w-100" elevation="0">
      <v-row>
        <v-col class="flex-grow-1">
          <v-toolbar-title class="page-title">Campanha Circuito</v-toolbar-title>
        </v-col>
        <v-col cols="2">
          <v-tooltip top :disabled="!travaInventario">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  class="new-button w-100"
                  color="primary"
                  :disabled="travaInventario"
                  @click="$refs.formulario.novo()"
                >
                  <v-icon left>mdi-plus-thick</v-icon> Criar acordo
                </v-btn>
              </div>
            </template>
            <span>Criação de acordo desabilitada até a finalização da aprovação do inventário.</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                class="new-button w-100"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-microsoft-excel</v-icon>
                Exportar
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportar()">
                <v-list-item-title>Exportação Acordos</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <FiltroCircuito ref="filtro" @filtrar="filtrar" @limpar="limpar" />
    </v-card>
    <Indicadores ref="indicadores" :indicadores="indicadores" :statusIndicadores="statusIndicadores" @toggleStatus="toggleStatusIndicador" />
    <v-card elevation="0" class="br-15 pa-5 involucroAcordo">
      <TabelaCircuito
        v-model="acordoSelecionado"
        :headers="headers"
        :acordos="acordos"
        :status="status"
        :usuario-tipo="usuarioTipo"
        :trava-inventario="travaInventario"
        :server-items-length="totalAcordos"
        item-key="id_acordo"
        show-select
        fixed-header
        multi-sort
        :items-per-page="5"
        :footer-props="{
            'items-per-page-options': [5, 10, 15, 25, 50, 100, 500, -1],
            itemsPerPageText: 'Linhas por páginas',
            ofText: 'de',
            pageText: '{0}-{1} de {2}',
        }"
        :options.sync="pagination"
        class="tabela paginacao-esquerda flex-table"
        @editar="editarAcordo"
        @exibir="exibirAcordo"
        @renovar="renovar"
        @replicar="replicarAcordo"
        @cancelar="cancelarAcordo"
        @liberar="liberarUmAcordo"
      />
      <!-- Removido fechamento incorreto de TabelaCircuito -->
      <!-- Botões de ação em massa -->
      <div class="table-footer-prepend d-flex pl-2 pt-4 align-center justify-end">
        <v-btn
          class="new-button ml-5"
          color="primary"
          @click="aprovarAcordos"
          :disabled="!acordoSelecionado.length"
        >
          <v-icon left>mdi-check-circle</v-icon> Aprovar Acordos
        </v-btn>
        <v-btn
          class="new-button ml-5"
          color="error"
          @click="reprovarAcordos"
          :disabled="!acordoSelecionado.length"
        >
          <v-icon left>mdi-close-circle</v-icon> Reprovar Acordos
        </v-btn>
        <v-btn
          class="new-button ml-5"
          color="primary"
          @click="liberarAcordos"
          :disabled="!acordoSelecionado.length"
        >
          <v-icon left>mdi-check</v-icon> Liberar acordos
        </v-btn>
      </div>
    </v-card>
    <Dialogo ref="dialogo" @aprovarAcordo="aprovarAcordo" @liberarAcordo="liberarAcordo" @filtrar="filtrar" />
    <Formulario ref="formulario" @filtrar="filtrar" />
    <v-overlay :value="carregando">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="alerta" :color="alertaColor" :timeout="alertaTimeout" top style="z-index: 400">
      <v-alert :type="alertaColor">
        {{ alertaTexto }}
      </v-alert>
      <v-btn dark text class="float-right" @click="alerta = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>


<script>

import FiltroCircuito from './_components/FiltroCircuito.vue'
import Indicadores from './Indicadores.vue'
import TabelaCircuito from './TabelaCircuito.vue'
import Dialogo from './Dialogo.vue'
import Formulario from './formulario/formulario.vue'

export default {
    mounted() {
      this.filtrar();
    },
    async beforeCreate() {
      // Carrega a tabela de permissões por status (mesma fonte do PDV)
      try {
        const response = await this.$http().post('/acordoCampanhaCircuito/status', {});
        this.status = response.data;
      } catch (e) {
        this.status = [];
      }
    },
  name: 'CampanhaCircuito',
  components: {
    FiltroCircuito,
    Indicadores,
    TabelaCircuito,
    Dialogo,
    Formulario
  },
  data() {
    return {
      usuarioTipo: 'rd',
      travaInventario: false,
      acordoSelecionado: [],
      acordos: [],
      totalAcordos: 0,
      indicadores: {},
      statusIndicadores: [],
      carregando: false,
      alerta: false,
      alertaTexto: '',
      alertaColor: 'error',
      alertaTimeout: 3000,
      status: [],
      fnAprovar: false,
      fnLiberar: false,
      pagination: {
        sortDesc: [true],
        sortBy: [],
      },
      headers: [
        { text: 'Menu', value: 'actions', sortable: false, align: 'center', class: 'th-separador' },
        { text: 'Acordo', value: 'id_acordo', align: 'center', class: 'th-separador' },
        { text: 'Acordo RD', value: 'acordo_rd', align: 'center', class: 'th-separador' },
        { text: 'Fornecedor', value: 'fornecedor', align: 'center', class: 'th-separador' },
        { text: 'Espaço', value: 'espaco', align: 'center', class: 'th-separador' },
        { text: 'Bandeira', value: 'bandeira', align: 'center', class: 'th-separador' },
        { text: 'Mês', value: 'mes', align: 'center', class: 'th-separador' },
        { text: 'Ano', value: 'ano', align: 'center', class: 'th-separador' },
        { text: 'Contrato', value: 'id_contrato', align: 'center', class: 'th-separador' },
        { text: 'Contrato RD', value: 'contrato', align: 'center', class: 'th-separador' },
        { text: 'Parcela', value: 'parcela', sortable: false, align: 'center', class: 'th-separador' },
        { text: 'Status', value: 'status', align: 'center', class: 'th-separador' },
        { text: 'Just. Reprov.', value: 'justificativa_reprovacao', align: 'center', class: 'th-separador' },
        { text: 'Just. Cancel.', value: 'justificativa_cancelamento', align: 'center', class: 'th-separador' },
        { text: 'Produtos', value: 'produtos', align: 'center', class: 'th-separador' },
        { text: 'Prod. Edit.', value: 'produtos_alterados', align: 'center', class: 'th-separador' },
        { text: 'Valor', value: 'valor', align: 'center', class: 'th-separador' },
        {text: 'Desconto Percentual%', value: 'desconto_percentual', align: 'center', class: 'th-separador' },
        { text: 'Desconto', value: 'desconto', align: 'center', class: 'th-separador' },
        {text: 'Desconto Total', value: 'desconto_total', align: 'center', class: 'th-separador' },
        { text: 'Investimento', value: 'investimento', align: 'center', class: 'th-separador' },
        { text: 'Justificativa Desconto', value: 'justificativa', align: 'center', class: 'th-separador' },
        { text: 'Usuário que Criou', value: 'usuario_criacao', sortable: true, align: 'center', class: 'th-separador' },
        { text: 'Cód. Fornecedor', value: 'codigo', align: 'center', class: 'th-separador' },
        { text: 'IDs Acordo PDV', value: 'ids_pdv', align: 'center', class: 'th-separador' },
      ],
    }
  },
  computed: {
    mesAtual() {
      return this.$moment ? this.$moment().format('YYYY-MM') : ''
    },
    mesAnterior() {
      return this.$moment ? this.$moment().subtract(1, 'months').format('YYYY-MM') : ''
    },
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar(false)
      },
      deep: true,
    },
  },
  methods: {
        limpar() {
          // Limpa os campos do filtro chamando o método limpar do FiltroCircuito
          if (this.$refs.filtro && typeof this.$refs.filtro.limpar === 'function') {
            this.$refs.filtro.limpar();
          }
          // Limpa também a seleção dos cards de status
          this.statusIndicadores = [];
          // Recarrega a lista com filtros limpos
          this.filtrar();
        },
        toggleStatusIndicador(id_status) {
          // Seleção única (igual PDV): clicar de novo no mesmo card desmarca
          this.statusIndicadores = this.statusIndicadores.includes(id_status)
            ? []
            : [id_status];
          this.filtrar();
        },
    statusAcesso(id_status, acesso) {
      if (this.status) {
        var status = this.status.find((e) => e.id_status == id_status)
        return status && status[acesso]
      } else {
        return false
      }
    },
    apenasLeitura(id_espaco) {
      // Acesso RD não tem restrição de leitura (mesma regra do PDV)
      if (this.usuarioTipo == 'rd') return false
      const lista = this.$refs.filtro && this.$refs.filtro.lista
      if (lista && Array.isArray(lista.espacoSomenteLeitura)) {
        return lista.espacoSomenteLeitura.find((e) => e.id_espaco == id_espaco)
      }
      return false
    },
    async filtrar(paginaInicial = true) {
            // if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            this.acordoSelecionado = [];

            var filtro = this.$refs.filtro;

            var data = {};
            console.log('filtro', filtro)
            data.mesInicial = filtro.periodoInicial
                ? filtro.periodoInicial
                : this.$moment().format("YYYY-MM");
            data.mesFinal = filtro.periodoFinal
                ? filtro.periodoFinal
                : this.$moment().format("YYYY-MM");
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1;

            data.bandeira = filtro.bandeira ?? '';
            data.id_espaco = filtro.id_espaco;
            data.espaco_macro = filtro.espaco_macro;
            data.id_fornecedor = filtro.id_fornecedor;
            data.id_status = filtro.id_status ? filtro.id_status : [];
            data.id_acordo = filtro.id_acordo ? [filtro.id_acordo] : [];
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : [];
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : [];
            data.id_cluster = filtro.id_cluster ? filtro.id_cluster : [];
            data.id_usuario = filtro.id_usuario ? filtro.id_usuario : [];
            data.contrato = filtro.contrato ? [filtro.contrato] : [];
            data.regiao = filtro.regiao ? filtro.regiao : []
            data.id_lote = filtro.id_lote ? [filtro.id_lote] : []
            data.visivel = filtro.visivel ? [filtro.visivel] : [];
            data.planograma = filtro.planograma;
            data.statusIndicadores = this.statusIndicadores;
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];

            if (paginaInicial) this.pagination.page = 1;

            data.pagination = this.pagination;

            var response = await this.$http().post("/acordoCampanhaCircuito/lista", {
                data: data,
            });
            this.acordos = response.data.lista //.map(item => {
            this.totalAcordos = response.data.total;
            this.indicadores = response.data.indicadores;

            if (this.acordos.length == 0 && this.pagination.page > 1) {
                this.filtrar();
            }
            // this.fnLiberar = ((data.id_status[0] == 29) && (([1,2].includes(this.$store.getters.getUsuario.id_cargo)))) ? true : false;

            this.carregando = false;
        },
    async exportar() {
      // Exemplo: ajuste endpoint conforme backend de campanha circuito
      // if (!this.$refs.filtro.validate()) return
      this.carregando = true
      const filtro = this.$refs.filtro;
      console.log('filtro para exportação', filtro)
      const data = { 
        exportar: true,
                  mesInicial: filtro.periodoInicial
                ? filtro.periodoInicial
                : this.$moment().format("YYYY-MM"),
            mesFinal: filtro.periodoFinal
                ? filtro.periodoFinal
                : this.$moment().format("YYYY-MM"),
            tipoPeriodo: filtro.tipoPeriodo ? filtro.tipoPeriodo : -1,

            bandeira: filtro.bandeira ?? '',
            id_espaco: filtro.id_espaco,
            espaco_macro: filtro.espaco_macro,
            id_fornecedor: filtro.id_fornecedor,
            id_status: filtro.id_status ? filtro.id_status : [],
            id_acordo: filtro.id_acordo ? [filtro.id_acordo] : [],
            acordo_rd: filtro.acordo_rd ? [filtro.acordo_rd] : [],
            id_contrato: filtro.id_contrato ? [filtro.id_contrato] : [],
            id_cluster: filtro.id_cluster ? filtro.id_cluster : [],
            id_usuario: filtro.id_usuario ? filtro.id_usuario : [],
            contrato: filtro.contrato ? [filtro.contrato] : [],
            regiao: filtro.regiao ? filtro.regiao : [],
            id_lote: filtro.id_lote ? [filtro.id_lote] : [],
            visivel: filtro.visivel ? [filtro.visivel] : [],
            planograma: filtro.planograma,
            statusIndicadores: this.statusIndicadores,
            id_macrofornecedor: filtro.id_macrofornecedor ? filtro.id_macrofornecedor : []
    }

      const response = await this.$http().post('/acordoCampanhaCircuito/exportar', { data: data })
      window.location = this.$http('baseURL') + response.data.url
      this.carregando = false
    },
    async aprovarAcordo(payload) {
      // Handler chamado pelo Dialogo (evento aprovarAcordo)
      this.carregando = true;
      let acordos = Array.isArray(payload) ? payload : [payload];
      // Chamada de API (ajuste endpoint conforme backend)
      try {
        const response = await this.$http().post('/acordoCampanhaCircuito/aprovarAcordo', {
          data: { acordos }
        });
        if (response.data && response.data.sucesso) {
          this.filtrar(false);
          this.alerta = true;
          this.alertaColor = 'success';
          this.alertaTexto = 'Acordo(s) aprovado(s) com sucesso!';
        } else {
          this.alerta = true;
          this.alertaColor = 'error';
          this.alertaTexto = response.data && response.data.msg ? response.data.msg : 'Erro ao aprovar acordo(s)';
        }
      } catch (e) {
        this.alerta = true;
        this.alertaColor = 'error';
        this.alertaTexto = 'Erro de comunicação com o servidor.';
      }
      this.carregando = false;
    },
    async liberarAcordo(payload) {
      // Handler chamado pelo Dialogo (evento liberarAcordo)
      this.carregando = true;
      let acordos = Array.isArray(payload) ? payload : [payload];
      try {
        const response = await this.$http().post('/acordoCampanhaCircuito/liberarAcordo', {
          data: { acordos }
        });
        if (response.data && response.data.sucesso) {
          this.filtrar(false);
          this.alerta = true;
          if (response.data.msgSemRd) {
            // Lote misto: parte foi liberada, parte ficou por falta de acordo RD
            this.alertaColor = 'warning';
            this.alertaTexto = response.data.msgSemRd;
          } else {
            this.alertaColor = 'success';
            this.alertaTexto = response.data.msg ? response.data.msg : 'Acordo(s) liberado(s) com sucesso!';
          }
        } else {
          this.alerta = true;
          this.alertaColor = 'error';
          this.alertaTexto = response.data && response.data.msg ? response.data.msg : 'Erro ao liberar acordo(s)';
        }
      } catch (e) {
        this.alerta = true;
        this.alertaColor = 'error';
        this.alertaTexto = 'Erro de comunicação com o servidor.';
      }
      this.carregando = false;
    },
    aprovarAcordos() {
      // Aprova acordos selecionados
      if (this.$refs.dialogo && typeof this.$refs.dialogo.aprovar === 'function') {
        this.$refs.dialogo.aprovar(this.acordoSelecionado)
      }
    },
    reprovarAcordos() {
      // Reprova acordos selecionados
      if (this.$refs.dialogo && typeof this.$refs.dialogo.reprovar === 'function') {
        this.$refs.dialogo.reprovar(this.acordoSelecionado)
      }
    },
    parseInvestimento(valor) {
      // Converte "R$ 1.234,56" em number
      if (typeof valor !== 'string') return valor || 0
      return parseFloat(valor.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) || 0
    },
    liberarAcordos() {
      // Libera os acordos selecionados (botão de ação em massa)
      const acordos = this.acordoSelecionado.map((a) => a.id_acordo)
      const total = this.acordoSelecionado.reduce((a, e) => a + this.parseInvestimento(e.investimento), 0)
      if (this.$refs.dialogo && typeof this.$refs.dialogo.liberar === 'function') {
        this.$refs.dialogo.liberar(acordos, total)
      }
    },
    liberarUmAcordo(item) {
      // Libera um único acordo (ação da linha)
      if (this.$refs.dialogo && typeof this.$refs.dialogo.liberar === 'function') {
        this.$refs.dialogo.liberar([item.id_acordo], this.parseInvestimento(item.investimento))
      }
    },
    editarAcordo(item, leitura = false) {
      // Edita acordo (modo leitura opcional)
      if (this.$refs.formulario && typeof this.$refs.formulario.editar === 'function') {
        if (leitura) {
          this.$refs.formulario.editar(item, true)
        } else {
          this.$refs.formulario.editar(item)
        }
      } else {
        console.warn('Formulário não encontrado em $refs')
      }
    },
    exibirAcordo(item) {
      // Exibe acordo em modo leitura
      if (this.$refs.formulario && typeof this.$refs.formulario.editar === 'function') {
        this.$refs.formulario.editar(item, true)
      }
    },
    renovar(item) {
      // Abre o diálogo de renovação (período + clusters)
      if (this.$refs.dialogo && typeof this.$refs.dialogo.renovacao === 'function') {
        this.$refs.dialogo.renovacao(item)
      }
    },
    replicarAcordo(item) {
      // Replicar acordo trocando a bandeira (RAIA <-> DROGASIL)
      if (this.$refs.formulario && typeof this.$refs.formulario.replicarAcordo === 'function') {
        this.$refs.formulario.replicarAcordo(item, 'bandeira')
      }
    },
    cancelarAcordo(item) {
      // Cancelar acordo (abrir diálogo de confirmação)
      if (this.$refs.dialogo && typeof this.$refs.dialogo.cancelar === 'function') {
        this.$refs.dialogo.cancelar(item)
      }
    },
    // ...existing code...
  },
}
</script>

<style scoped>
</style>
